import React, { useState } from 'react';

import styled, { css } from 'styled-components';
import { HideScrollbarCSS, StyledButton } from 'styles/common';

import theme from 'constants/theme';

import { Typography13 } from 'uiToolkit/Typography';

const blueBorderCSS = css`
  border-bottom: 3px solid ${theme.palette.primary.main};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

const StyledNavButton = styled(StyledButton)`
  border-bottom: 3px solid transparent;
  ${(props) => props.selected && blueBorderCSS};
`;

const NavItem = ({ children, isSelected = false, handleOnClick, rightGutter = 2 }) => (
  <StyledNavButton
    disableFocusRipple
    disableRipple
    onClick={handleOnClick}
    selected={isSelected}
    rightGutter={rightGutter}
  >
    {children}
  </StyledNavButton>
);

const ScrollableContainer = styled.div`
  position: relative;
  height: calc(100% - 4rem);
  overflow-y: auto;
  top: 4rem;
  ${HideScrollbarCSS};
  padding-right: 1rem;
`;

const NavigationBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 1rem;
  border-bottom: 1px solid lightgrey;
`;

const StyledContainer = styled.div`
  position: relative;
  flex: 1;
  overflow: hidden;
  margin: 0;
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.3;
  `};
`;

const ClickToSetNavBar = ({
  sectionList = [],
  defaultSelectedIndex = 0, // index of default selected when renders
  onNavigateToSection = () => {},
  className,
}) => {
  const [selectedNav, setSelectedNav] = useState(sectionList.length > 0 ? sectionList[defaultSelectedIndex].id : '');

  const selectedComponent = sectionList?.find(({ id }) => id === selectedNav);

  if (!selectedComponent) {
    return null;
  }

  return (
    <StyledContainer className={className}>
      <NavigationBar>
        {sectionList.map(({ id, header, rightGutter }) => (
          <NavItem
            key={id}
            isSelected={id === selectedNav}
            handleOnClick={() => {
              setSelectedNav(id);
              onNavigateToSection(id);
            }}
            rightGutter={rightGutter}
          >
            <Typography13 color={id === selectedNav ? theme.palette.primary.main : 'textSecondary'} cursor="pointer">
              {header(id === selectedNav)}
            </Typography13>
          </NavItem>
        ))}
      </NavigationBar>
      <ScrollableContainer>
        <div key={selectedComponent?.id}>{selectedComponent?.component()}</div>
      </ScrollableContainer>
    </StyledContainer>
  );
};

export default ClickToSetNavBar;
